<template>
    <ui-model-provider v-model="isChecked" v-slot="{ updateValue }">
        <ui-radio v-bind="$attrs" @change="onUpdate($event, updateValue)">
            <template v-slot:label>
                <slot name="label"/>
            </template>
        </ui-radio>
    </ui-model-provider>
</template>

<script>
    import UiModelProvider from '@dreipol/vue-ui/src/components/form/model-provider/model-provider';
    import UiRadio from '@dreipol/vue-ui/src/components/form/radio/radio.vue';
    import { mapActions } from 'vuex';

    export default {
        components: {
            UiModelProvider,
            UiRadio,
        },
        props: {
        },
        data() {
            return {
                isChecked: false,
            };
        },
        methods: {
            ...mapActions('wizard', ['updateWizardReferenceAuthorization']),
            onUpdate($event, updateValue) {
                this.updateWizardReferenceAuthorization({ value: $event.currentTarget.value });
                updateValue($event);
            },
        },
        mounted() {
            this.updateWizardReferenceAuthorization({ value: this.value });
        },
    };
</script>
